import React, { useEffect, useState } from "react";
import { fetchInsiderDocumentBlob } from "../../services/misc.service";
import {
    getApprovalTrackCodesService,
    approveInsiderUserByAdminService,
    rejectInsiderUserByAdminService,
} from "../../services/misc.service";

function getFileType(blob) {
    if (blob.type.startsWith("image/")) return "image";
    if (blob.type === "application/pdf") return "pdf";
    return "other";
}

const InsiderDocumentViewer = () => {
    const params = new URLSearchParams(window.location.search);
    const dqInsiderId = params.get('file_id');

    const [fileName, setFileName] = useState("");
    const [blobUrl, setBlobUrl] = useState("");
    const [blobType, setBlobType] = useState("");
    const [error, setError] = useState("");
    const [showDoc, setShowDoc] = useState(false);

    const [approvalCode, setApprovalCode] = useState("");
    const [rejectionCode, setRejectionCode] = useState("");
    const [memberId, setMemberId] = useState("");
    const [actionLoading, setActionLoading] = useState(false);
    const [actionResult, setActionResult] = useState("");

    useEffect(() => {
        if (!dqInsiderId) return;
        getApprovalTrackCodesService(dqInsiderId)
            .then(resp => {
                if (resp.data) {
                    setApprovalCode(resp.data.approval_code);
                    setRejectionCode(resp.data.rejection_code);
                    setMemberId(resp.data.member_id);
                }
            })
            .catch(() => console.log("Failed to fetch approval codes."));
    }, [dqInsiderId]);

    useEffect(() => {
        return () => {
            if (blobUrl) URL.revokeObjectURL(blobUrl);
        };
    }, [blobUrl]);

    const handleViewDocument = () => {
        const newShowState = !showDoc;
        setShowDoc(newShowState);

        if (!newShowState || blobUrl || !dqInsiderId) return;

        setActionLoading(true);

        fetchInsiderDocumentBlob(dqInsiderId)
            .then(response => {
                const { data: base64Data, mimeType, fileName } = response;

                const byteCharacters = atob(base64Data);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: mimeType });
                const url = URL.createObjectURL(blob);

                setBlobUrl(url);
                setBlobType(getFileType(blob));
                setFileName(fileName);
            })
            .catch(() => setError("Failed to fetch document."))
            .finally(() => setActionLoading(false));
    };

    const handleApprove = async () => {
        if (!memberId || !approvalCode) return;
        setActionLoading(true);
        try {
            await approveInsiderUserByAdminService(memberId, approvalCode);
            setActionResult("approved");
        } catch {
            setError("Failed to approve user.");
        }
        setActionLoading(false);
    };

    const handleReject = async () => {
        if (!memberId || !rejectionCode) return;
        setActionLoading(true);
        try {
            await rejectInsiderUserByAdminService(memberId, rejectionCode);
            setActionResult("rejected");
        } catch {
            setError("Failed to reject user.");
        }
        setActionLoading(false);
    };

    if (!dqInsiderId) {
        return <div style={{ padding: 30, textAlign: "center" }}><h2>No document ID provided</h2></div>;
    }
    if (error) return <div style={{ padding: 30, textAlign: "center" }}><h2>{error}</h2></div>;

    return (
        <div style={{ width: "100vw", background: "#fff", borderRadius: 14, boxShadow: "0 2px 16px #eee", padding: 0 }}>
            <div style={{ display: "flex", justifyContent: "center", gap: 24, marginTop: 30, marginBottom: 24, paddingBottom: 20 }}>
                <button
                    onClick={handleViewDocument}
                    style={{
                        padding: "10px 24px",
                        background: "#2396f3",
                        color: "#fff",
                        borderRadius: 8,
                        border: "none",
                        fontSize: 16,
                        fontWeight: "bold",
                        cursor: "pointer",
                        boxShadow: "0 2px 5px #ddd"
                    }}
                >
                    {showDoc ? "Hide Document" : "View Document"}
                </button>
                <button
                    onClick={handleApprove}
                    disabled={actionLoading}
                    style={{
                        padding: "10px 24px",
                        background: "#28a745",
                        color: "#fff",
                        borderRadius: 8,
                        border: "none",
                        fontSize: 16,
                        fontWeight: "bold",
                        cursor: "pointer",
                        boxShadow: "0 2px 5px #ddd"
                    }}
                >
                    Approve
                </button>
                <button
                    onClick={handleReject}
                    disabled={actionLoading}
                    style={{
                        padding: "10px 24px",
                        background: "#dc3545",
                        color: "#fff",
                        borderRadius: 8,
                        border: "none",
                        fontSize: 16,
                        fontWeight: "bold",
                        cursor: "pointer",
                        boxShadow: "0 2px 5px #ddd"
                    }}
                >
                    Reject
                </button>
            </div>
            {/* This is the new confirmation message below the buttons */}
            {actionResult && (
                <div style={{
                    textAlign: "center",
                    paddingBottom: 20,
                    fontWeight: "bold",
                    fontSize: 12,
                    color: actionResult === "approved" ? "#28a745" : "#dc3545"
                }}>
                    {actionResult === "approved" ? "Application has been Approved!" : "Application has been Rejected!"}
                </div>
            )}
            {showDoc && (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "calc(100vh - 200px)",
                        width: "95vw",
                        overflow: "hidden",
                        paddingBottom: 10,
                    }}
                >
                    {actionLoading ? (
                        <div style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                        }}>
                            <div style={{
                                border: "4px solid #f3f3f3",
                                borderTop: "4px solid #3498db",
                                borderRadius: "50%",
                                width: "40px",
                                height: "40px",
                                animation: "spin 1s linear infinite"
                            }} />
                            <style>{`
                                @keyframes spin {
                                0% { transform: rotate(0deg); }
                                100% { transform: rotate(360deg); }
                                }
                            `}</style>
                        </div>
                    ) : (
                        blobType === "image" ? (
                            <img
                                src={blobUrl}
                                alt={fileName}
                                style={{
                                    maxWidth: "100%",
                                    maxHeight: "100%",
                                    borderRadius: 12,
                                    boxShadow: "0 2px 8px #888",
                                    display: "block",
                                    margin: "0 auto",
                                }}
                            />
                        ) : (
                            <iframe
                                src={blobUrl}
                                title={fileName}
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    border: "none",
                                    borderRadius: 12,
                                    boxShadow: "0 2px 8px #888",
                                    display: "block",
                                    margin: "0 auto",
                                }}
                            />
                        )
                    )}
                </div>
            )}
        </div>
    );
}

export default InsiderDocumentViewer;